import { Stack } from "@mantine/core";
import CustomAttributeSectionMantine from "../../../../../../components/CustomAttributes/CustomAttributeSectionMantine";
import LocalErrorBoundary from "../../../../../../util/LocalErrorBoundary";
import IssueConnectionsSection from "./IssueConnectionsSection";
import IssueDiscussionSection from "./IssueDiscussionSection";
import { IssueItemModalGanttActivities } from "./IssueItemModalGanttActivities";
import { IIssueModalSectionProps } from "./IssueItemModalMantine";
import { IssueItemRisikoSectionMantine } from "./IssueItemRisikoSectionMantine";
import IssueItemTimeSection from "./IssueItemTimeSection";
import { IssueMainPropertiesSection } from "./IssueMainPropertiesSection";
import { IssueTodoSection } from "./IssueTodoSection";

const IssueModalInfo = ({ issueBoard, issue, projectId }: IIssueModalSectionProps) => {
  const showIssueCAConfig =
    issue.taskOrIssue === "ISSUE" && Object.keys(issueBoard?.otherAttributesConfig ?? {}).length > 0;
  const showTaskCAConfig =
    issue.taskOrIssue === "TASK" && Object.keys(issueBoard?.otherAttributesTasksConfig ?? {}).length > 0;

  return (
    <Stack gap="sm">
      <LocalErrorBoundary id="IssueMainPropertiesSection">
        <IssueMainPropertiesSection issueBoard={issueBoard} issue={issue} projectId={projectId} />
      </LocalErrorBoundary>
      <LocalErrorBoundary id="IssueItemTimeSection">
        <IssueItemTimeSection issueBoard={issueBoard} issue={issue} projectId={projectId} />
      </LocalErrorBoundary>
      {issueBoard.risikoSection?.isActive && issue.taskOrIssue === "ISSUE" && (
        <LocalErrorBoundary id="IssueItemRisikoSection">
          <IssueItemRisikoSectionMantine issueBoard={issueBoard} issue={issue} projectId={projectId} />
        </LocalErrorBoundary>
      )}
      {import.meta.env.DEV === true && (
        <LocalErrorBoundary id="IssueItemGanttSection">
          <IssueItemModalGanttActivities issue={issue} projectId={projectId} />
        </LocalErrorBoundary>
      )}
      {showIssueCAConfig && (
        <LocalErrorBoundary id="IssueCustomAttributeSection">
          <CustomAttributeSectionMantine
            issue={issue}
            projectId={projectId}
            attributeConfig={issueBoard?.otherAttributesConfig}
            data={issue.otherAttributesData ?? {}}
          />
        </LocalErrorBoundary>
      )}
      {showTaskCAConfig && (
        <LocalErrorBoundary id="TaskCustomAttributeSection">
          <CustomAttributeSectionMantine
            issue={issue}
            projectId={projectId}
            attributeConfig={issueBoard?.otherAttributesTasksConfig}
            data={issue.otherAttributesData ?? {}}
          />
        </LocalErrorBoundary>
      )}
      <LocalErrorBoundary id="IssueTodoSection">
        <IssueTodoSection issue={issue} projectId={projectId} />
      </LocalErrorBoundary>
      <LocalErrorBoundary id="IssueDiscussionSection">
        <IssueDiscussionSection issue={issue} projectId={projectId} />
      </LocalErrorBoundary>
      <LocalErrorBoundary id="IssueConnectionsSection">
        <IssueConnectionsSection issue={issue} projectId={projectId} />
      </LocalErrorBoundary>
    </Stack>
  );
};

export default IssueModalInfo;
